import React, { Component } from "react";
import Login from "./Login";

import "./AuthContainer.scss";
import ReactGA from "react-ga";
// import CompanyLogo from "../../assets/radarr-logo-black.png";
import MainImage from "./main-image1.png";
import { Link } from "react-router-dom";
import { ReactComponent as RadarrLogo } from "../../assets/radarr-logo-green.svg";
import Scrollbars from "react-custom-scrollbars";
import { isMobile } from "react-device-detect";
import { connect } from "react-redux";
import { updateRouteValues } from "../../actions/globalAction";
import { toast } from "react-toastify";

class AuthContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: null,
        };
    }

    componentDidMount() {
        if (zE) {
            zE("webWidget", "updateSettings", { color: { theme: "#00bfa3" } });
            zE("webWidget", "show");
        }

        // console.log("first", this.props);
        const parsedUrl = new URL(window.location.href);
        if (parsedUrl.searchParams.get("access_token")) {
            localStorage.setItem("accessToken", parsedUrl.searchParams.get("access_token"));
            localStorage.setItem("userId", parsedUrl.searchParams.get("user_id"));
            // toast.success("");
            this.props.history.push("/gettingStarted");
        } else if (parsedUrl.searchParams.get("error")) {
            // this.setState({
            //     errorMessage: decodeURIComponent(parsedUrl.searchParams.get("message")),
            // });
            toast.error(decodeURIComponent(parsedUrl.searchParams.get("message")));
            this.props.history.push("/signin");
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.pathname != window.location.pathname) {
            let route = {
                to: window.location.pathname,
                from: prevProps.location.pathname,
            };
            this.props.updateRouteValues(route);
        }
    }

    componentWillUnmount() {
        zE("webWidget", "hide");
    }

    render() {
        return (
            <div className="auth-container">
                <div className="auth-navbar">
                    <RadarrLogo />
                    {this.props.location.pathname.includes("/signup") ? (
                        <Link to="/signin">
                            <div className="navbar-button">Sign In</div>
                        </Link>
                    ) : (
                        <Link to="/signup">
                            <div className="navbar-button">Sign Up</div>
                        </Link>
                    )}
                </div>
                <div className="auth-contents">
                    <div className="auth__left-wrap">
                        <div className="main__dummy__text">
                            {/* <p>You have successfully authenticated with Microsoft Azure.</p> */}
                            <p></p>
                            <p className="warning__text">Oops!.. We have encountered an Error</p>
                            <p className="warning__text">
                                {this.state.errorMessage ? this.state.errorMessage : "Something went wrong. Please try again later"}
                            </p>
                            <p>
                                If you believe this is an error, please contact your company administrator or email us on{" "}
                                <a href="mailto: support@radarr.com">support@radarr.com</a>
                            </p>
                        </div>
                        <div className="main-image">
                            <img src={MainImage} />
                        </div>
                        <p style={{ color: "#fff", paddingLeft: "30px" }}>Radarr helps 1000+ brands globally get actionable insights</p>
                        <div className="company-logos">
                            <img src="https://d1u68zc0161z8s.cloudfront.net/wp-content/uploads/2021/07/discovery-networks-logo.png" alt="Discovery" />
                            <img src="https://d1u68zc0161z8s.cloudfront.net/wp-content/uploads/2021/07/twitter-logo.png" alt="Twitter" />
                            <img src="https://d1u68zc0161z8s.cloudfront.net/wp-content/uploads/2021/07/glico-logo.png" alt="Glico" />
                            <img src="https://d1u68zc0161z8s.cloudfront.net/wp-content/uploads/2021/07/quantum-logo.png" alt="Quantum" />
                            <img src="https://d1u68zc0161z8s.cloudfront.net/wp-content/uploads/2021/07/toyota-logo-1.png" alt="Toyota" />
                            {/* <img src="https://d1u68zc0161z8s.cloudfront.net/wp-content/uploads/2021/07/hong-leong-bank-logo.png" alt="Toyota" /> */}
                            <img src="https://d1u68zc0161z8s.cloudfront.net/wp-content/uploads/2021/07/mapletree-logo.png" alt="Mapletree" />
                        </div>
                    </div>
                    <div className="auth-right">
                        <Scrollbars
                            autoHide
                            renderView={(props) => <div {...props} className={`auth-scrollbar-view ${isMobile ? "auth-scrollbar-view-mobile" : ""}`} />}>
                            {/* <Switch>
                                <Route path="/signin" component={Login} />

                                <Route path="/forgetpassword" component={ForgetPassword} />
                                <Route path="/resetpassword" component={ResetPassword} />
                                <Route path="/email-verify" component={EmailVerification} />
                                <Route path="/oauth-linkedin" component={AuthLinkedin} />
                            </Switch> */}
                            <Login />
                            {/* <div className="privacy__policy">
                                <a href="https://www.radarr.com/terms-of-use/" target="_blank" rel="noreferrer">
                                    <span className="privacy__text">Terms and Conditions </span>
                                </a>{" "}
                                <span className="privacy__text-separate"> | </span>{" "}
                                <a href="https://www.radarr.com/privacypolicy" target="_blank" rel="noreferrer">
                                    {" "}
                                    <span className="privacy__text">Privacy Policy </span>
                                </a>
                            </div> */}
                        </Scrollbars>
                    </div>
                </div>
            </div>
        );
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        updateRouteValues: (args) => dispatch(updateRouteValues(args)),
    };
};

export default connect(null, mapDispatchToProps)(AuthContainer);
